const initialState = {
  listClient: [],
};

const clientReducerSulutgo = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_ALLCLIENT":
      return {
        ...state,
        listClient: data,
      };
    default:
      return state;
  }
};
export default clientReducerSulutgo;
